import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import { Typography } from "antd";

import styles from "components/PlatformLayout/components/PlatformPageHeader/PlatformPageHeader.module.less";

const { Title } = Typography;

const GettingStartedBreadCrumbs = () => {
  const [tabTitle, setTabTitle] = useState(null);
  const params = useParams();
  const history = useHistory();

  useEffect(() => {
    if (params.tab) setTabTitle(params.tab.replace(/-/g, " "));
    if (params.modal === "payment") setTabTitle("Payment");
  }, [params]);

  const handleBaseNavigate = () => {
    history.push("/getting-started");
  };

  const baseStyle = {
    cursor: "pointer",
    textTransform: "capitalize",
    fontWeight: 600,
  };

  const secondaryStyle = {
    textTransform: "capitalize",
  };

  return (
    <>
      <Title className={styles.title} style={baseStyle} onClick={handleBaseNavigate}>
        Getting Started
      </Title>
      {tabTitle && (
        <>
          <span className={styles.titleSeparator}>/</span>
          <Title className={styles.titleSecondary} style={secondaryStyle}>
            {tabTitle}
          </Title>
        </>
      )}
    </>
  );
};

export default GettingStartedBreadCrumbs;
